/**
 * 匹配接口。
 * 契约：POST /match → {results: MatchResult[], weights: string}
 *
 * 注意：**前端不实现任何匹配算法**。分数、四项分量、池内百分位、理由、缺失技能
 * 全部来自后端返回的 MatchResult；前端只用 shared 的 explainScore() 生成文案。
 */
import { api } from './client.js';
import type { MatchRequestPayload, MatchResponseDto, MatchSummaryDto, MatchSummaryPayload } from './types.js';

export const matchApi = {
  run: (payload: MatchRequestPayload): Promise<MatchResponseDto> => api.post<MatchResponseDto>('/match', payload),
  summarize: (payload: MatchSummaryPayload): Promise<MatchSummaryDto> =>
    api.post<MatchSummaryDto>('/match/summary', payload),
};